import { useNavigate, useSearchParams } from "react-router-dom";
import Topbar from "@/components/Topbar";
import { XCircle } from "@phosphor-icons/react";

/**
 * v3.2.31 · Stripe Checkout cancel landing. User bailed out of the
 * hosted checkout — no charge was made. Show a friendly nudge and
 * bounce back to the milestone.
 */
export default function PaymentCancelPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const jobId    = params.get("job_id");
  const msIdx    = params.get("ms");
  const backHref = jobId ? `/jobs/${jobId}#milestone-${(Number(msIdx) || 1) - 1}` : "/jobs";

  return (
    <div className="industrial min-h-screen bg-[#0A0C10]">
      <Topbar />
      <div className="max-w-2xl mx-auto px-6 md:px-10 py-16">
        <div className="label-tag">// checkout</div>
        <h1 className="mt-2 font-display text-4xl md:text-5xl font-black tracking-tighter"
            data-testid="payment-cancel-heading">
          Payment cancelled
        </h1>

        <div className="mt-8 border border-white/10 p-6 md:p-8"
             data-testid="payment-cancel-card">
          <div className="flex items-start gap-4">
            <XCircle size={40} weight="fill" className="text-gray-500" />
            <div>
              <div className="text-white font-display text-lg">No charge was made</div>
              <div className="text-gray-400 text-sm mt-2">
                You closed the Stripe checkout before completing payment.
                The milestone is still marked released — pay it any time from the job page.
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex items-center gap-3">
          <button onClick={() => navigate(backHref)}
            className="btn-primary text-sm py-2"
            data-testid="payment-cancel-back-btn">
            Back to milestone →
          </button>
        </div>
      </div>
    </div>
  );
}
